import React from "react";
import { useOutletContext } from "react-router-dom";
import SessionLengthAnalyzer from "./SessionLengthAnalyzer";

export function SessionLengthPage() {
  const { isAdmin } = useOutletContext();

  return (
    <div>
      <div className="mb-8">
        <div>
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-200">
            Session Length Analyzer
          </h2>
          <p className="mt-2 text-sm text-gray-400">
            Analyze player session lengths and retention rates over time
          </p>
        </div>
      </div>

      <div className="bg-[#18181B] rounded-xl shadow-xl shadow-black/20 p-4 sm:p-6">
        <SessionLengthAnalyzer isAdmin={isAdmin} />
      </div>
    </div>
  );
}
